// extracted by mini-css-extract-plugin
export var headerCellWrapper = "HeaderCell-module--headerCellWrapper--49624";